import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import { theme } from '../theme';
import { Button } from './ui';

const Shell = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }
`;

const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(20, 14, 38, 0.98), rgba(12, 8, 26, 0.98));
  border-right: 1px solid rgba(255, 20, 147, 0.2);
  padding: 1rem 0.85rem;
  min-height: 0;

  @media (max-width: 900px) {
    border-right: none;
    border-bottom: 1px solid rgba(255, 20, 147, 0.2);
    padding-bottom: 0.65rem;
  }
`;

const Brand = styled.div`
  font-family: ${theme.fonts.heading};
  font-size: 1rem;
  color: ${theme.colors.pink};
  margin-bottom: 1.25rem;
  letter-spacing: 1.5px;
  padding: 0 0.35rem;
`;

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;

  @media (max-width: 900px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.35rem;
  }

  a {
    padding: 0.55rem 0.7rem;
    border-radius: 9px;
    color: ${theme.colors.textMuted};
    font-size: 0.86rem;
    font-weight: 500;
    transition: 0.15s ease;
    border: 1px solid transparent;

    &:hover {
      color: #fff;
      background: rgba(255, 20, 147, 0.08);
    }

    &.active {
      color: #fff;
      background: linear-gradient(90deg, rgba(255, 20, 147, 0.22), rgba(123, 44, 191, 0.12));
      border-color: rgba(255, 20, 147, 0.35);
      box-shadow: inset 0 0 20px rgba(255, 20, 147, 0.08);
    }
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.65rem 1.15rem;
  border-bottom: 1px solid rgba(255, 20, 147, 0.12);
  background: rgba(8, 5, 18, 0.55);
  flex-shrink: 0;
`;

const Content = styled.div`
  flex: 1;
  overflow: auto;
  padding: 0.85rem 1.15rem 1.25rem;
`;

const Layout: React.FC = () => {
  const { admin, logout } = useAuth();

  return (
    <Shell>
      <Sidebar>
        <Brand>EUGENIAL</Brand>
        <Nav>
          <NavLink to="/" end>Dashboard</NavLink>
          <NavLink to="/users">Usuarios</NavLink>
          <NavLink to="/cards">Cartas</NavLink>
          <NavLink to="/commands">Comandos</NavLink>
          <NavLink to="/auctions">Subastas</NavLink>
          <NavLink to="/alerts">Alertas</NavLink>
          <NavLink to="/oraculos">Oráculos</NavLink>
          <NavLink to="/oraculos/configuracion">Configuración Oráculos</NavLink>
          <NavLink to="/oraculos/asignados">Oráculos asignados</NavLink>
          <NavLink to="/oraculos/monitor">Oráculos monitor</NavLink>
          <NavLink to="/cowork">Cowork</NavLink>
          <NavLink to="/extensible">Extensible</NavLink>
          <NavLink to="/config">Configuración</NavLink>
        </Nav>
      </Sidebar>
      <Main>
        <TopBar>
          <span style={{ color: theme.colors.textMuted, fontSize: '0.84rem' }}>
            Panel admin {admin ? `· ${admin.username}` : ''}
          </span>
          <Button $variant="ghost" $size="sm" onClick={logout}>Salir</Button>
        </TopBar>
        <Content>
          <Outlet />
        </Content>
      </Main>
    </Shell>
  );
};

export default Layout;
